define(
    'utils/toast',[
        'jquery',

        'settings'
    ],

    function ($, settings) {
        /**
         * @class Toast
         */
        var Toast = (function () {
            var DEFAULT_DURATION = 3000,
                HTML = '<div class="toast" id="toast"><span class="toast__message"></span></div>';

            /**
             * Toast constructor
             * @constructor
             */
            function Toast() {}

            /**
             * Contains all the queued toasts
             *
             * @property q
             * @type {Array}
             */
            Toast.prototype.q = [];

            /**
             * Queue a new toast
             *
             * @method queue
             * @param message
             * @param duration
             * @param error
             * @returns {{cancel: cancel}}
             */
            Toast.prototype.queue = function (message, duration, error) {
                if (error === undefined) {
                    error = false;
                }

                if (duration === undefined) {
                    duration = DEFAULT_DURATION;
                }

                this.q.push({
                    message: message,
                    length: duration,
                    error: error
                });
                this._show();

                var _this = this,
                    index = this.q.length - 1;
                return { cancel: function () {
                    _this.q.splice(index, 1);
                }};
            };

            /**
             * Queue an error toast
             *
             * @method queueError
             * @param message
             * @param duration
             * @returns {{cancel: cancel}}
             */
            Toast.prototype.queueError = function (message, duration) {
                return this.queue(message, duration, true);
            };

            Toast.prototype.cancelAll = function () {
                this.q = [];
            };

            /**
             * Show the queued toasts
             *
             * @method _show
             * @private
             */
            Toast.prototype._show = function () {
                var _this = this;

                if (this.showing === true) {
                    return;
                }

                if (this.q.length > 0) {
                    var toastObj = this.q.splice(0, 1)[0],
                        toast = this._getToastFromDOM();

                    this._setMessage(toastObj.message);
                    this.showing = true;
                    toast.addClass('toast--visible');

                    if (toastObj.error) {
                        toast.addClass('toast--error');
                    } else {
                        toast.removeClass('toast--error');
                    }

                    setTimeout(function () {
                        _this._next();
                    }, toastObj.length);
                }
            };

            Toast.prototype._next = function () {
                var next = (this.q.length > 0);

                this._hide(!next);
                this.showing = false;

                if (next) {
                    this._show();
                }
            };

            /**
             * Hide the toast obj
             *
             * @method _hide
             * @param remove
             * @private
             */
            Toast.prototype._hide = function (remove) {
                var toast = this._getToastFromDOM(),
                    _this = this;

                toast.removeClass('toast--visible');

                if (remove) {
                    setTimeout(function () {
                        toast.remove();
                        _this.toast = null;
                    }, settings.transitionTime);
                }
            };

            /**
             * Set the message of the toast element
             *
             * @method _setMessage
             * @param message
             * @private
             */
            Toast.prototype._setMessage = function (message) {
                this._getToastFromDOM().find('.toast__message').text(message);
            };

            /**
             * Get the actual toast element from the DOM
             *
             * @method _getToastFromDOM
             * @returns {null|*}
             * @private
             */
            Toast.prototype._getToastFromDOM = function () {
                var toast = (this.toast)? this.toast : $('#toast');

                if (!toast.length) {
                    toast = $(HTML).appendTo('.navigation-bar');
                }
                
                this.toast = toast;

                return this.toast;
            };

            return Toast;
        })();

        return new Toast();
    }
);
